<div class="construction-container">
  <div class="construction-content">
    <img src="assets/images/banner.png" alt="Hero Image" class="img-fluid hero-image mb-4">
    <div class="construction-icon">
      <i class="fas fa-hard-hat"></i>
    </div>
    <h1>Página em Construção</h1>
    <p class="construction-message">
      Estamos trabalhando para trazer uma experiência ainda melhor para você.
      Em breve, esta página estará disponível com todas as funcionalidades.
    </p>
    <div class="construction-details">
      <div class="detail-item">
        <i class="fas fa-tools"></i>
        <span>Em desenvolvimento</span>
      </div>
      <div class="detail-item">
        <i class="fas fa-clock"></i>
        <span>Em breve</span>
      </div>
      <div class="detail-item">
        <i class="fas fa-star"></i>
        <span>Novidades chegando</span>
      </div>
    </div>
    <button class="btn btn-primary mt-4" routerLink="/cliente">
      <i class="fas fa-home me-2"></i>
      Voltar para a Página Inicial
    </button>
  </div>
</div> 